export default __webpack_public_path__ + "6ff4740ea5d8b741baf47d80f8f7cd56.png";